// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__24XTM","info":"PatientInfo_info__3poF1"};